









































































































































































































	import Vue from 'vue';
	import truncateStringMiddle from '../helpers/truncateStringMiddle';
	import Filter from './Filter.vue';
	import ResultsPreview from './ResultsPreview.vue';
	import SelectWithCustom from './SelectWithCustom.vue';

	const $ = window.jQuery;

	export default Vue.extend({
		data: function () {
			return this.defaultData();
		},
		components: {
			'gppa-filter': Filter,
			'gppa-results-preview': ResultsPreview,
			'gppa-select-with-custom': SelectWithCustom,
		},
		created: function () {
			for ( const [property, fieldSetting] of Object.entries(this.fieldSettingMap) ) {
				this.$watch(property, (val, oldVal) => {
					try {
						if (typeof val !== 'undefined') {
							SetFieldProperty(fieldSetting, JSON.parse(JSON.stringify(val)));
						}
					} catch (e) {
						console.warn(e);
					}
				}, {deep: true});
			}
		},
		props: [
			'field',
			'populate',
		],
		watch: {
			field: {
				handler: function (field, prevField) {
					/* Disable GPPA if 'enableCalculation' is enabled on the current field */
					if ('enableCalculation' in field && field.enableCalculation) {
						this.enabled = false;
					}

					if (prevField && field.id === prevField.id) {
						return;
					}

					this.initialLoad();
				},
				deep: true,
			},
			objectType: function () {
				if (!this.objectTypeInstance) {
					return;
				}

				if ('primary-property' in this.objectTypeInstance && !this.usingFieldObjectType) {
					this.getPropertyValues('primary-property');
				} else {
					this.getProperties();
				}
			},
			primaryProperty: function () {
				if (!this.objectTypeInstance) {
					return;
				}

				if (this.usingFieldObjectType && !('primary-property' in this.objectTypeInstance)) {
					return;
				}

				this.getProperties();
			},
			enabled: function (val) {

				this.toggleStaticChoices();
				this.toggleEnabledClass();

			},
		},
		computed: {
			fieldSettingMap: function () {
				var prefix = 'gppa-' + this.populate + '-';

				return {
					'enabled': prefix + 'enabled',
					'objectType': prefix + 'object-type',
					'primaryProperty': prefix + 'primary-property',
					'orderingProperty': prefix + 'ordering-property',
					'orderingMethod': prefix + 'ordering-method',
					'filterGroups': prefix + 'filter-groups',
					'templates': prefix + 'templates',
					'uniqueResults': prefix + 'unique-results',
				};
			},
			isRestrictedObjectTypeActive: function () {
				return this.objectTypeInstance && this.objectTypeInstance.restricted;
			},
			fieldSettingConversion: function () {
				var prefix = 'gppa-' + this.populate + '-';

				return {
					'templates': function () {
						if (window.field && prefix + 'templates' in window.field) {
							var value = window.field[prefix + 'templates'];

							if (typeof value !== 'undefined' && Array.isArray(value)) {
								return {};
							}

							return value;
						}

						return undefined;
					}
				};
			},
			objectTypeInstance: function () {
				if (!this.objectType) {
					return null;
				}

				if (this.usingFieldObjectType) {
					var targetFieldSettings = this.fieldObjectTypeTargetFieldSettings;

					if (!targetFieldSettings || !targetFieldSettings['gppa-choices-object-type'] || !window.GPPA_ADMIN.objectTypes[targetFieldSettings['gppa-choices-object-type']]) {
						this.objectType = '';

						return;
					}

					var fieldObjectType = window.GPPA_ADMIN.objectTypes[targetFieldSettings['gppa-choices-object-type']];

					return Object.assign({}, fieldObjectType);
				}

				return Object.assign({}, window.GPPA_ADMIN.objectTypes[this.objectType]);
			},
			primaryPropertyComputed: function () {
				if (this.usingFieldObjectType) {
					return this.fieldObjectTypeTargetFieldSettings['gppa-choices-primary-property'];
				}

				return this.primaryProperty;
			},
			usingFieldObjectType: function () {
				return this.objectType.indexOf('field_value_object') === 0;
			},
			fieldObjectTypeTargetFieldSettings: function () {
				if (!this.usingFieldObjectType) {
					return null;
				}

				var targetFieldID = this.objectType.split(':')[1];

				return window.form.fields.filter(function (field) {
					return field.id == targetFieldID;
				})[0];
			},
			fieldValueObjects: function () {

				var vm = this;

				return window.form.fields.filter(function (field) {
					if (!('choices' in field)) {
						return false;
					}

					if (field.id === vm.field.id) {
						return false;
					}

					return 'gppa-choices-enabled' in field && field['gppa-choices-enabled'] && field['gppa-choices-object-type'];
				});

			},
			groupedProperties: function () {
				var groupedProperties = Object.assign({}, this.properties);
				delete groupedProperties.ungrouped;

				return groupedProperties;
			},
			ungroupedProperties: function () {
				return this.properties.ungrouped;
			},
			orderingProperties: function () {
				return Object.values(this.flattenedProperties).filter(function (prop) {
					return 'orderby' in prop && prop.orderby;
				});
			},
			flattenedProperties: function () {
				var propertiesFlat = {};
				var vm = this;

				Object.keys(this.properties).forEach(function (group) {
					var groupProperties = vm.properties[group];

					groupProperties.forEach(function (property) {
						propertiesFlat[property.value] = property;
					});
				});

				return propertiesFlat;
			},
			currentFieldSettings: function () {

                var currentFieldSettings = window.fieldSettings[ this.field.type ];
                if( this.field.type !== this.field.inputType ) {
                    currentFieldSettings += ',' + window.fieldSettings[ this.field.inputType ];
				}

				return $.map(currentFieldSettings.split(','), function (value) {
					return value.trim();
				});
			},
			isSupportedField: function () {
				if (!this.field) {
					return false;
				}

				/* Exclude specific field types */
				if (['consent', 'tos', 'list'].indexOf(this.field.type) !== -1) {
					return false;
				}

				switch (this.populate) {
					case 'choices':
						if ( this.hasChoices() ) {
							/* Exclude chained selects */
							if (this.field.choices[0] && 'choices' in this.field.choices[0]) {
								return false;
							}

							return true;
						}

						if (['workflow_user'].indexOf(this.field.type) !== -1) {
							return true;
						}

						break;

					case 'values':
						if ( this.hasChoices() ) {
							/* Exclude chained selects */
							if (this.field.choices[0] && 'choices' in this.field.choices[0]) {
								return false;
							}

							return true;
						}

						/* Single input */
						if (this.currentFieldSettings.indexOf('.default_value_setting') !== -1) {
							return true;
						}

						/* Textarea */
						if (this.currentFieldSettings.indexOf('.default_value_textarea_setting') !== -1) {
							return true;
						}

						/* Input with multiple fields */
						if (this.currentFieldSettings.indexOf('.default_input_values_setting') !== -1) {
							return true;
						}

						if ( this.field.inputType === 'singleproduct' ) {
							return true;
						}

						break;
				}

				return false;
			},
			templateRows: function () {
				var templateRows = [];

				if (!this.field) {
					return templateRows;
				}

				switch (this.populate) {
					case 'choices':
						templateRows.push({id: 'value', label: this.i18nStrings.value, required: true});
						templateRows.push({id: 'label', label: this.i18nStrings.label, required: true});

						if ('basePrice' in this.field || this.field.type === 'option') {
							templateRows.push({id: 'price', label: this.i18nStrings.price, required: true});
						}
						break;

					case 'values':
						if (
							this.field.inputs
							&& !window.GPPA_ADMIN.interpretedMultiInputFieldTypes.includes(this.field.type)
							&& !window.GPPA_ADMIN.multiSelectableChoiceFieldTypes.includes(this.field.type)
						) {
							for ( const input of this.field.inputs ) {
								if (input.isHidden) {
									continue;
								}

								templateRows.push({id: input.id, label: input.label});
							}
						} else {
							templateRows.push({id: 'value', label: this.i18nStrings.value});
						}
						break;
				}

				/**
				 * Modify the templates that will be shown under Choice Templates and/or Value Templates.
				 *
				 * @since 1.0-beta-4.116
				 *
				 * @param {Object[]} The available template rows. Each template should have an "id" string, "label" string, and "required" boolean.
				 * @param {Object}   The current field shown in the Form Editor.
				 * @param {String}   What's being populated. Either "choices" or "values"
				 */
				return window.gform.applyFilters( 'gppa_template_rows', templateRows, this.field, this.populate );
			},
		},
		methods: {
			truncateStringMiddle: truncateStringMiddle,
			getObjectTypes: function () {
				return window.GPPA_ADMIN.objectTypes;
			},
			isSuperAdmin: function () {
				return window.GPPA_ADMIN.isSuperAdmin;
			},
			defaultData: function () {
				return {
					enabled: false,
					uniqueResults: true,
					objectType: '',
					primaryProperty: '',
					properties: [],
					propertyValues: {},
					orderingProperty: '',
					orderingMethod: 'asc',
					filterGroups: [],
					i18nStrings: window.GPPA_ADMIN.strings,
					multiSelectableChoiceFieldTypes: window.GPPA_ADMIN.multiSelectableChoiceFieldTypes,
					templates: {},
				};
			},
			initialLoad: function () {
				var vm = this;

				Object.assign(vm.$data, this.defaultData());

				for ( const [property, fieldSetting] of Object.entries(this.fieldSettingMap) ) {
					if (typeof vm.fieldSettingConversion[property] === 'function') {
						var value = vm.fieldSettingConversion[property]();

						if (typeof value !== 'undefined') {
							vm.$data[property] = value;
						}

						continue;
					}

					if ( !window.field ) {
						continue;
					}

					if (fieldSetting in window.field) {
						vm.$data[property] = window.field[fieldSetting];
					}
				}

				if (!this.enabled || !this.isSupportedField) {
					this.showStaticSettings();

					return;
				}

				this.hideStaticSettings();

				if (!this.objectTypeInstance) {
					return;
				}

				if ('primary-property' in this.objectTypeInstance && !this.usingFieldObjectType) {
					this.getPropertyValues('primary-property');

					if (!this.primaryProperty) {
						return;
					}
				}

				this.getProperties();

				for ( const filters of this.filterGroups ) {
					for ( const filter of filters ) {
						vm.getPropertyValues(filter.property);
					}
				}
			},
			showStaticSettings: function () {

				if (!this.isSupportedField) {
					return;
				}

				switch (this.populate) {
					case 'choices':
						if ( $.inArray( window.field.type, [ 'post_category' ] ) === -1 ) {
							window.field.choices && window.field.choices.length && $('.choices_setting').show();
						}
						break;
					case 'values':
                        if( $.inArray( GetInputType( GetSelectedField() ), [ 'number', 'calculation' ] ) !== -1 ) {
                            $('.calculation_setting').show();
						}
					    break;
				}
			},
			hideStaticSettings: function () {

				if (!this.isSupportedField) {
					return;
				}

				switch (this.populate) {
					case 'choices':
						window.field.choices && $('.choices_setting').hide();
						break;
					case 'values':
						if (window.fieldSettings[window.field.type] && window.fieldSettings[window.field.type].indexOf('calculation_setting') !== -1) {
							window.ToggleCalculationOptions(false, window.GetSelectedField());
							$('.calculation_setting').hide();
						}
					    break;
				}
			},
			toggleStaticChoices: function () {
				if (this.enabled === true) {
					this.hideStaticSettings();
				} else if (this.enabled === false) {
					this.showStaticSettings();
				}
			},
			toggleEnabledClass: function () {
				const $field = $('.gfield').filter('#field_' + this.field.id);

				if (this.enabled === true) {
					$field.addClass('gppa-' + this.populate + '-enabled');
				} else if (this.enabled === false) {
					$field.removeClass('gppa-' + this.populate + '-enabled');
				}
			},
			changeObjectType: function () {
				this.propertyValues = this.defaultData().propertyValues;
				this.primaryProperty = this.defaultData().primaryProperty;
				this.filterGroups = this.defaultData().filterGroups;
				this.properties = this.defaultData().properties;
				this.orderingProperty = this.defaultData().orderingProperty;
				this.orderingMethod = this.defaultData().orderingMethod;

				if (typeof this.objectTypeInstance.templates === 'object' && Object.keys(this.objectTypeInstance.templates).length) {
					this.templates = Object.assign({}, this.objectTypeInstance.templates);
				} else {
					this.templates = this.defaultData().templates;
				}
			},
			changePrimaryProperty: function () {
				this.filterGroups = this.defaultData().filterGroups;
			},
			filterFactory: function () {
				var date = new Date();

				return {
					property: '',
					operator: 'is',
					value: '',
					uuid: date.getTime(),
				};
			},
			addFilterGroup: function () {
				this.filterGroups.push([this.filterFactory()])
			},
			addFilter: function (filterIndex, filterGroupIndex) {
				if (!isNaN(filterIndex)) {
					this.filterGroups[filterGroupIndex].splice(filterIndex + 1, 0, this.filterFactory());

					return;
				}

				this.filterGroups[filterGroupIndex].push(this.filterFactory());
			},
			removeFilter: function (index, filterGroupIndex) {
				this.filterGroups[filterGroupIndex].splice(index, 1);

				if (this.filterGroups[filterGroupIndex].length === 0) {
					this.filterGroups.splice(filterGroupIndex, 1);
				}
			},
			resetPropertyValues: function (keepPrimaryPropertyValues) {
				var primaryPropertyValues = Object.assign({}, this.propertyValues['primary-property'] || {});
				this.propertyValues = this.defaultData().propertyValues;

				if (keepPrimaryPropertyValues && Object.keys(primaryPropertyValues).length) {
					this.propertyValues['primary-property'] = primaryPropertyValues;
				}
			},
			getProperties: function () {
				this.resetPropertyValues(true);

				var ajaxArgs = {
					'action': 'gppa_get_object_type_properties',
					'object-type': this.objectTypeInstance.id,
					'populate': this.populate,
				};

				if ('primary-property' in this.objectTypeInstance && this.primaryPropertyComputed) {
					ajaxArgs['primary-property-value'] = this.primaryPropertyComputed;
				}

				var vm = this;

				$.post(ajaxurl, ajaxArgs, null, 'json').done(function (data) {
					vm.properties = Object.assign({}, data);
				});
			},
			getPropertyValues: function (property) {
				var vm = this;

				if (property instanceof Event) {
					property = property.target.value;
				}

				if (property in vm.propertyValues) {
					return vm.propertyValues[property];
				}

				var ajaxArgs = {
					'action': 'gppa_get_property_values',
					'object-type': this.objectTypeInstance.id,
					'property': property
				};

				if ('primary-property' in this.objectTypeInstance && this.primaryPropertyComputed && property !== 'primary-property') {
					ajaxArgs['primary-property-value'] = this.primaryPropertyComputed;
				}

				$.post(ajaxurl, ajaxArgs, null, 'json').done(function (data) {
					if (data === 'gppa_over_max_values_in_editor') {
						/**
						 * If gppa_max_property_values_in_editor filter is met, do not output any properties to be selected.
						 *
						 * Instead, a custom value or special value should by used by the user.
						 *
						 * This is done for usability purposes but also to help browsers from locking up if there are a huge number of
						 * results.
						 */
						vm.$set(vm.propertyValues, property, [
							{
								value: '',
								label: vm.i18nStrings.tooManyPropertyValues,
								disabled: true,
							}
						]);

						return;
					}

					/* See https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats */
					vm.$set(vm.propertyValues, property, $.map(data, function (option, index) {
						var value = option;
						var label = option;

						if (Array.isArray(option)) {
							value = option[0];
							label = option[1];
						}

						return {
							value: value,
							label: label
						}
					}));
				});
			},
			hasChoices: function() {
                return 'choices' in this.field && this.field.choices !== '' && this.field.choices !== null;
			}
		}
	});
